/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-caret-sort': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5.625 7.5L10 2.5l4.375 5h-8.75zm8.75 5L10 17.5l-4.375-5h8.75z"/>'
  }
})
